import { useEffect, useState } from 'react';
import './App.css';
import { useDispatch } from 'react-redux';
import { setIAAM, setProfile } from './redux/iaamSlice';
import UserPermission from './pages/UserPermission';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';
import Main from './pages/Main';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NotFoundPage from './pages/NotFoundPage';
import LayoutWrapper from './pages/LayoutWrapper';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
        white: {
            main: '#fff',
        },
        gray: {
            main: '#939393'
        },
        warning: {
            main: '#ffc107'
        },
        error: {
            main: '#d32f2f'
        }
    },
    typography: {
        fontFamily: [
            'Noto Sans Thai',
        ].join(','),
        button: {
            textTransform: "none"
        }
    }
});

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_KEY);

// const mockProfile = {
//     sub: "tAOciG8BlPJPiwHgE9FrB0XWua7UkldPZ-BTrZW6ekQ",
//     gender: "male",
//     registerTimestamp: "1684482330376",
//     telephone: "0842284007",
//     newOrgId: "-",
//     inum: "3b86a708571fa929e5349895865055840ef40206de8083388be6fbca44f8e997",
//     statusNewOrg: "-",
//     updateTimestamp: "1784613448814",
//     orgId: "12254",
//     dob: "871232400000",
//     appId: "Web-Test-API-Python,tanrabad-api-python,IAAM-Testbed-AA-Web,IAAM-Testbed-AA-API,IAAM-Testbed-WEB,IAAM-Testbed-API,iaamreg_api,landing-ddccare-dashboard,landing-page-iaam-client,landing-page-local-aon-2,landing-page-local-aon,ddc-care-aa-api,iaam-aa,iaamreg_local_dan,iaamreg_demo44_local_dan,iaam-aa-demo,iaamdocker-aa,trb2-quality-api-python,tanrabad-eoc-api,client_oauth_tools,web-clientiaam,api-iaamclient,survey_native_privatescheme,Web-Demo,trb-watch-local,trb-report-local,trb-secure-api-local,trb-report-production,ADMINROOTAN_LOCAL,APIROOTAN_LOCAL,TanRabad-Workshop,ddccare-api-workshop,IAAM-Workshop,Vallaris,ADMINROOTAN_PUBLIC,trb-eoc-local,TanRabadEOC-WebLocalManot,trb-watch-production,dpe,oidc-playground,RULEEDITOR_LOCAL,efr,RULEEDITOR_PUBLIC,APIRULEEDITOR_PUBLIC,Policy-Editor-Local,Superset,ss_oidc,iaam-aa-workshop,ddccare-workshop,iaam_ram_local,trbaa,iaamaa,ipe_localhost,DPE_Service,trb-response-local,trb_eoc_local,TRB-Survey,ddc-care-api-test,ddccare-aa,DPE-Service-HR,ips-validation-api,openid_test,ipe-api-test,ddccare-aa-api,DPE_Service_HR,iaam-rereg,iaamrereg_api,ipe,web-bff-authen,iaamram,iaamram_api,openwebui",
//     iaamregPrivilege: "usermgt,clientmgt,orgmgt,privilegemgt",
//     position: "STAFF",
//     department: "IT",
//     userApproved: "true",
//     uid: "dantanapon@gmail.com",
//     givenName: "ธนพล",
//     sn: "โยธานัก",
//     displayName: "ธนพล โยธานัก",
//     emailVerified: "true",
//     mail: "dantanapon@gmail.com",
//     org_id: "12254",
//     org_name: "กรมควบคุมโรค (ส่วนกลาง)",
//     p_org_id: "null",
//     province_code: "12",
//     province_name: "นนทบุรี",
//     amphur_code: "1201",
//     amphur_name: "เมืองนนทบุรี",
//     tambon_code: "120103",
//     tambon_name: "บางเขน",
//     org_type: "01",
//     org_level: "01",
//     area_code: "all",
//     location: "null",
//     update_timestamp: 1723099949349,
//     import_check: 0,
//     is_org_active: 1,
//     org_type_name: "สาธารณสุข",
//     org_level_name: "ประเทศ",
//     temporary_org: [],
//     areaCode: [
//         "all"
//     ]
// }

function App() {

    let iaam = window.iaam;
    const dispatch = useDispatch();

    const [isUserApproved, setIsUserApproved] = useState();

    useEffect(() => {
        iaam.initLoginFlow({
            client_id: process.env.REACT_APP_CLIENT_ID,
            iaamgw_host: `https://${process.env.REACT_APP_IAAM_GW_HOST}`,
            op_host: `https://${process.env.REACT_APP_OP_HOST}`,
            post_logout_uri: process.env.REACT_APP_POST_LOGOUT,
            // redirect_uri: process.env.REACT_APP_POST_LOGOUT, // เพิ่มใน version 1.7
        })
            .then((init) => {
                iaam.isLoggedIn((error, status) => {
                    if (!status) {
                        iaam.login()
                    } else {
                        iaam.getProfile((error, profile) => {
                            if (error) {
                                iaam.login()
                            } else {
                                dispatch(setIAAM(iaam));
                                dispatch(setProfile(profile));
                                setIsUserApproved(profile?.userApproved === "true");
                            }
                        })
                    }
                })
            })
            .catch(err => {
                console.error(err);
            });

        // dispatch(setIAAM(iaam));
        // dispatch(setProfile(mockProfile));
        // setIsUserApproved(mockProfile?.userApproved === "true");
    }, []);

    return (
        <div className="App">
            <ThemeProvider theme={theme}>
                <Router>
                    <Routes>
                        <Route path="/*" element={isUserApproved === undefined ? <></> :
                            isUserApproved ? <Main /> : <UserPermission />
                        }></Route>
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </Router>
            </ThemeProvider>
        </div >
    );

    // return (
    //     <ThemeProvider theme={theme}>
    //         <Router>
    //             <Routes>
    //                 <Route path="/" element={isUserApproved === undefined ? <></> :
    //                     isUserApproved ? <LayoutWrapper /> : <UserPermission />
    //                 }>
    //                     <Route path="/" element={<ProjectPage />} />
    //                     <Route path="/editor" element={<EditorPage />} >
    //                         <Route path="workspace" element={<ProjectWorkSpace />} />
    //                         <Route path="regulatory" element={<RegulatoryPage />} />
    //                     </Route>
    //                     <Route path="/simulator" element={<SimulatorPage />} />
    //                     <Route path="/deployer" element={<DeployerRoutePage />} >
    //                         <Route path="workspace" element={<DeployWorkspace />} />
    //                     </Route>
    //                     <Route path="*" element={<NotFoundPage />} />

    //                 </Route>
    //             </Routes>
    //         </Router>
    //     </ThemeProvider>
    // );

}

function RouteWrapper() {
    return
}

export default App;